import {
  FETCH_REQUESTED,
  FETCH_COMPLETED,
  DISPLAY_MESSAGE,
  HIDE_MESSAGE,
} from '../constants/Ui';

const initState = {
  loading: false,
  message: '',
  isError: false,
  showMessage: false,
};

const Ui = (state = initState, action) => {
  switch (action.type) {
    case FETCH_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COMPLETED:
      return {
        ...state,
        loading: false,
      };
    case DISPLAY_MESSAGE:
      return {
        ...state,
        showMessage: true,
        message: action.message.message,
        isError: action.message.isError,
      };
    case HIDE_MESSAGE:
      return {
        ...state,
        showMessage: false,
      };
    default:
      return state;
  }
};

export default Ui;
